export default __webpack_public_path__ + "static/media/side-menu.a371534d.svg";